'use strict';

module.exports = require('./Autocomplete');


/** WEBPACK FOOTER **
 ** ./build/lib/index.js
 **/